import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Share2, Mail, Link2, QrCode, MessageCircle, Facebook, Download } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { track } from "@/lib/api";

const btn = "inline-flex items-center gap-2 h-11 px-4 rounded-full border border-black/15 bg-white text-sm font-semibold hover:bg-amber-50 transition-colors";

export function QRButton({ url, title }) {
  const [open, setOpen] = useState(false);
  const download = () => {
    const c = document.getElementById("qr-canvas");
    const a = document.createElement("a");
    a.href = c.toDataURL("image/png");
    a.download = `qr-${title.slice(0, 40).replace(/\W+/g, "-")}.png`;
    a.click();
  };
  return (
    <>
      <button className={btn} onClick={() => { setOpen(true); track("qr", url); }} data-testid="qr-open-button"><QrCode className="h-4 w-4" aria-hidden />Código QR</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm text-center" data-testid="qr-dialog">
          <DialogTitle className="font-display text-xl">{title}</DialogTitle>
          <DialogDescription>Aponte a câmara do telemóvel para abrir esta página.</DialogDescription>
          <div className="mx-auto p-4 bg-white rounded-2xl border"><QRCodeCanvas id="qr-canvas" value={url} size={220} level="M" includeMargin /></div>
          <p className="text-xs break-all text-slate-500">{url}</p>
          <button className={`${btn} mx-auto`} onClick={download} data-testid="qr-download-button"><Download className="h-4 w-4" aria-hidden />Descarregar PNG</button>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default function ShareBar({ title, text = "", path }) {
  const url = `${window.location.origin}${path || window.location.pathname}`;
  const msg = `${title} — ${url}`;
  const native = async () => {
    try { await navigator.share({ title, text, url }); track("share", path); } catch { /* cancelled */ }
  };
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success("Ligação copiada"); track("share", path); };
  return (
    <div className="flex flex-wrap gap-2" data-testid="share-bar">
      {typeof navigator !== "undefined" && navigator.share && <button className={btn} onClick={native} data-testid="share-native-button"><Share2 className="h-4 w-4" aria-hidden />Partilhar</button>}
      <a className={btn} href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp"><MessageCircle className="h-4 w-4" aria-hidden />WhatsApp</a>
      <a className={btn} href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(msg)}`} data-testid="share-email"><Mail className="h-4 w-4" aria-hidden />Email</a>
      <a className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" data-testid="share-facebook"><Facebook className="h-4 w-4" aria-hidden />Facebook</a>
      <button className={btn} onClick={copy} data-testid="share-copy-link"><Link2 className="h-4 w-4" aria-hidden />Copiar ligação</button>
      <QRButton url={url} title={title} />
    </div>
  );
}
